import {useState} from 'react';
import {Box, Button, Grid, Group, Textarea} from '@mantine/core';
import {useForm} from '@mantine/form';
import {ArrowRight} from "tabler-icons-react";
import {homeHooks} from 'features/homes/hooks'
import {EUserEventType} from "features/homes/types";

interface Props {
    onSubmitQuery?: (query: any) => void,
    initialValues?: any
}

export function HomeSendMessageForm({onSubmitQuery, initialValues}: Props) {
    const [sendingMessage, setSendingMessage] = useState(false);

    const {mutateAsync: userClickEvent, isLoading: isUserClickEventLoading} =
            homeHooks.useUserClickEvent()

    const form = useForm<{ message:string }>({
        initialValues: initialValues || {},
        validate: {},
    });


    async function onSubmit(values: typeof form.values) {
        if (onSubmitQuery) {
            setSendingMessage(true);
            await onSubmitQuery(values)
            await userClickEvent({ eventType: EUserEventType.SentMessage, homeId: initialValues?.homeId, data: values.message })
            setSendingMessage(false);
        }
    }


    return (
        <Box mx="auto">
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Grid>
                    <Grid.Col>
                        <Textarea label="Your Message" {...form.getInputProps('message')}/>
                    </Grid.Col>
                    <Grid.Col sm={12}>
                        <Group position="right" mt="md">
                            <Button type="submit" loading={ sendingMessage }
                                    rightIcon={<ArrowRight/>}>
                                Send Message
                            </Button>
                        </Group>
                    </Grid.Col>
                </Grid>
            </form>
        </Box>
    )
}
